import { HostKYCReview } from '@/components/dashboard/HostKYCReview';

export default function HostKYCPage() {
  return <HostKYCReview />;
}
